import { useState } from "react";
import { UserContext } from "./UserContext.js";
import axios from "axios";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function UserProvider({ children }) {
  const userFromSessionStorage = sessionStorage.getItem("user");

  const [user, setUser] = useState(
    userFromSessionStorage
      ? JSON.parse(userFromSessionStorage)
      : { id: null, email: "", name: "", password: "", token: "" }
  );

  const [selectedCompany, setSelectedCompany] = useState(
  sessionStorage.getItem("selectedCompany")
    ? JSON.parse(sessionStorage.getItem("selectedCompany"))
    : null
  );

  const updateSelectedCompany = (companyObj) => {
    setSelectedCompany(companyObj);
    sessionStorage.setItem("selectedCompany", JSON.stringify(companyObj));
  };

  const signIn = async (email, password) => {
    try {
      const response = await axios.post(
        url + "/user/login",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const loggedInUser = response.data;

      const userToStore = {
        id: loggedInUser.user_id,
        email: loggedInUser.email,
        name: loggedInUser.name,
        token: loggedInUser.token,
        is_admin: loggedInUser.is_admin,
      };

      sessionStorage.setItem("user", JSON.stringify(userToStore));
      setUser(userToStore);
    } catch (error) {
      throw error;
    }
  };

  const signOut = async () => {
    const token = user?.token;

    // Clear local state first so components (Header, etc.) stop making auth calls.
    setUser({ id: null, email: "", token: "" });
    sessionStorage.removeItem("user");

    setSelectedCompany(null);
    sessionStorage.removeItem("selectedCompany");

    // Notify any listeners that cart/summary state is gone
    window.dispatchEvent(new Event("cart-updated"));

    if (!token) return;

    try {
      await axios.post(
        url + "/user/logout",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        signIn,
        signOut,
        selectedCompany,
        setSelectedCompany: updateSelectedCompany
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
